/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { RecordMobileTrackingEventsRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiNotificationTrackingEventsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-notification-tracking-events-controller
   * @name PublishTrackingEvents
   * @request POST:/api/v1/notification-tracking-events/mobile
   */
  publishTrackingEvents = (data: RecordMobileTrackingEventsRequest, params: RequestParams = {}) =>
    this.http.request<object, any>({
      path: `/v1/notification-tracking-events/mobile`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static publishTrackingEventsPath = '/v1/notification-tracking-events/mobile'
  static publishTrackingEventsMethod = 'POST'
}
